/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AssistantMessageSchemaRole = typeof AssistantMessageSchemaRole[keyof typeof AssistantMessageSchemaRole];


export const AssistantMessageSchemaRole = {
  user: 'user',
  assistant: 'assistant',
} as const;
